import { render, staticRenderFns } from "./outsource-settle-manage.vue?vue&type=template&id=19695760"
import script from "./outsource-settle-manage.vue?vue&type=script&lang=ts"
export * from "./outsource-settle-manage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports